import PropTypes from "prop-types";
import * as React from "react";
import { translate } from "react-i18next";
import { Button, ButtonGroup, ClanTag, DialogBody, DialogContainer, DialogFooter, DialogHeader, MessageWrap } from "@wg/wows-react-uikit";
import { Tooltip, TooltipHeader, TooltipBody } from "components";
import { getLocalizationSafe } from "helpers/localization";
import settings from "settings";

import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import styles from "./MonumentAchievementsDialog.scss";

const propTypes = {
  achievements: PropTypes.array,
  tag: PropTypes.string,
  color: PropTypes.string,

  hideDialog: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const MonumentAchievementsDialog = props => {
  const t = props.t;

  const mediaPath = settings.mediaPath;
  const achievementsData = settings.achievements.data;

  let achievements = !isEmpty(props.achievements) && !isEmpty(settings.achievements.data) ? map(props.achievements, achievement => {
    return achievementsData[achievement.cd] ? <div className={styles.achievementWrap} key={achievement.cd}>
                        <div className={styles.achievement} data-for={`tooltip-achievement-${achievement.cd}`}>
                            <img src={mediaPath + achievementsData[achievement.cd].icons.normal} alt="" />
                            <span className={styles.count}>{achievement.count > 1 && `x${achievement.count}`}</span>
                        </div>

                        <Tooltip id={`tooltip-achievement-${achievement.cd}`}>
                            <TooltipHeader isBold>
                                <span className={styles.tooltipHeader}>{getLocalizationSafe(achievementsData[achievement.cd], 'mark')}</span>
                            </TooltipHeader>
                            <TooltipBody>{getLocalizationSafe(achievementsData[achievement.cd], 'description')}</TooltipBody>
                        </Tooltip>
                    </div> : null;
  }) : <MessageWrap title={t('Достижения отсутствуют')} message={t('В настоящее время у клана нет достижений')} />;

  return <DialogContainer>
            <DialogHeader>
                <div className={styles.headerIcon}></div>
                <span className={styles.headerText}>{t('Достижения клана')}</span>
                <ClanTag clanTag={props.tag} clanColor={props.color} />
            </DialogHeader>
            <DialogBody>
                <div className={styles.achievementsContainer}>
                    {achievements}
                </div>
            </DialogBody>
            <DialogFooter>
                <ButtonGroup>
                    <Button isJustified onClick={props.hideDialog}>{t('Вернуться на базу')}</Button>
                </ButtonGroup>
            </DialogFooter>
        </DialogContainer>;
};

MonumentAchievementsDialog.propTypes = propTypes;

export default translate()(MonumentAchievementsDialog);